module.exports = __webpack_public_path__ + "img/polling-icon.e0412aa3.svg";